export const displayAdvertLineItemId = "displayAdvertLineItemId";

const addLineItemToUrl = (url, lineItemId) => {
  if (!lineItemId) {
    return url;
  }

  return `${url}#${displayAdvertLineItemId}-${lineItemId}`;
};

export default addLineItemToUrl;
